import { getRoot } from "mobx-state-tree"

export const merchantLogsViews = self => ({
  get formattedDate() {
    const date = new Date(self.lastUpdated)
    return date.toLocaleString('en-US')
  }
})